import { type JSX } from 'react';

export const ContextMenuSeparator = (): JSX.Element => {
  return <div className="contextMenu--separator" />;
};